import { MessageCircle } from "lucide-react";
import { getProductNameFromPath, trackEvent } from "@/lib/analytics";
import { useLocation } from "react-router-dom";

export const FloatingWhatsApp = () => {
  const { pathname } = useLocation();

  return (
    <a
      href="#tim-sales"
      data-testid="whatsapp-floating-btn"
      onClick={() =>
        trackEvent("whatsapp_float_clicked", {
          category: "contact",
          label: "Floating WhatsApp",
          source: "floating_button",
          product_name: getProductNameFromPath(pathname),
        })
      }
      className="fixed bottom-6 right-6 z-40 group"
    >
      <div className="absolute inset-0 rounded-full bg-animax-orange/40 blur-xl group-hover:blur-2xl transition-all animate-pulse" />
      <div className="relative flex items-center gap-3 pl-4 pr-5 py-3.5 rounded-full bg-animax-orange text-white shadow-lg shadow-animax-orange/30 hover:bg-animax-yellow hover:text-animax-black transition-all">
        <MessageCircle className="w-5 h-5" />
        <span className="text-sm font-medium hidden sm:inline">Hubungi Tim Sales</span>
      </div>
    </a>
  );
};
